import './languages/i18n';
import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import HomeRouter from './routes/homeRoutes';
import AuthRouter from './routes/authRoutes';
import { ToastContainer } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { getLoggedInUser } from './redux/features/auth/actions';
import { Box, LinearProgress } from '@mui/material';
import { getMessagingIfSupported, subscribeToMessages } from './firebase';
import { getToken } from 'firebase/messaging';
import { useTranslation } from 'react-i18next';
import { retrieveData, storeData } from './helper/storageHelper';
import { constants, showErrorTost } from './constants';
import { UPDATE_USER } from './apiService/apiDeclaration';
import { addNotification } from './redux/features/auth/slice';

export default function App() {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const { loading } = useSelector((state) => state.auth.status.user);
  const { user, token, language } = useSelector((state) => state.auth);

  async function requestPermission() {
    // vapidKey: process.env.REACT_APP_NOTIFICATION_KEY_DEVELOPMENT,
    const vapidKey = process.env.REACT_APP_NOTIFICATION_KEY_PRODUCTION;
    if (!vapidKey) {
      console.warn('REACT_APP_NOTIFICATION_KEY_PRODUCTION is not set — push notifications are disabled.');
      return;
    }

    const messaging = await getMessagingIfSupported();
    if (!messaging) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      if (permission === 'denied') {
        showErrorTost(t('common.notificationsDenied'));
      }
      return;
    }

    // Generate Token
    const notificationToken = await getToken(messaging, { vapidKey });
    storeData(constants.notificationToken, notificationToken);
    await UPDATE_USER(user._id, { notificationToken });
    // Send this token  to server ( db)
  }

  useEffect(() => {
    if (!user) {
      dispatch(getLoggedInUser());
    }
    const token = retrieveData(constants.notificationToken);
    if (!token && user) {
      requestPermission().catch((err) => console.warn('Notification setup failed:', err));
    }
    // eslint-disable-next-line
  }, [token, user]);

  useEffect(() => {
    // This effect previously had no dependency array, so it ran on every render and
    // registered a new onMessage listener each time without ever tearing one down.
    const unsubscribe = subscribeToMessages((payload) => {
      const date = Date.now();
      dispatch(
        addNotification({
          ...(language === 'ENGLISH'
            ? {
                enTitle: payload.data.title,
                enMessage: payload.data.body,
              }
            : {
                frTitle: payload.data.title,
                frMessage: payload.data.body,
              }),
          createdAt: date,
          orderId: payload?.data?.orderId ? JSON.parse(payload.data.orderId) : undefined,
        })
      );
    });

    return unsubscribe;
  }, [dispatch, language]);

  useEffect(() => {
    i18n.changeLanguage(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <>
      {loading ? (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      ) : user?.email ? (
        <HomeRouter />
      ) : (
        <AuthRouter />
      )}
      <ToastContainer />
    </>
  );
}
